import { defineStore } from "pinia";
import { api } from "@/configs";
import { apiUrls } from "@/constants";
import Swal from "sweetalert2";

export const useSplashScreenStore = defineStore("splashScreen", {
    state: () => ({
        splashScreen: [],
    }),

    actions: {
        async fetchSplashScreen() {
            try {
                const response = await api.get(apiUrls.splashScreen);
                this.splashScreen = response.data?.data ?? [];
            } catch (error) {
                this.splashScreen = [];
            }
        },

        async addSplashScreen(payload) {
            try {
                await api.post(apiUrls.splashScreen, payload, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                await this.fetchSplashScreen();

                await Swal.fire("Splash Screen Added Successfully", "", "success");
                return true;
            } catch (error) {
                await Swal.fire("Failed to add Splash Screen", "", "error");
                return false;
            }
        },

        async updateSplashScreen(splashScreenId, payload) {
            try {
                const formData = new FormData();
                formData.append("_method", "PATCH");

                Object.keys(payload).forEach((key) => {
                    if (payload[key] !== null && payload[key] !== undefined) {
                        formData.append(key, payload[key]);
                    }
                });

                await api.post(
                    `${apiUrls.splashScreen}/${splashScreenId}`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                await this.fetchSplashScreen();

                Swal.fire("Splash Screen Updated Successfully", "", "success");
                return true;
            } catch (error) {
                Swal.fire("Failed to update Splash Screen", "", "error");
                return false;
            }
        },

        async deleteSplashScreen(splashScreenId) {
            try {
                await api.delete(`${apiUrls.splashScreen}/${splashScreenId}`);

                // Correct way to remove item from array
                this.splashScreen = this.splashScreen.filter(
                    (splash) => splash.id !== splashScreenId
                );

                Swal.fire("Splash Screen Deleted Successfully", "", "success");
                return true;
            } catch (error) {
                console.error(error);
                Swal.fire("Failed to delete Splash Screen", "", "error");
                return false;
            }
        },

        async updateSplashScreenStatus(id) {
            try {
                await api.patch(
                    `${apiUrls.splashScreen}/status/${id}`
                );

                // Optional: re-fetch or update locally
                await this.fetchSplashScreen();

                Swal.fire("Status Updated Successfully", "", "success");
                return true;
            } catch (error) {
                Swal.fire("Failed to update status", "", "error");
                return false;
            }
        },
    },
});
